import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/enums/interactionType/findAll')
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/enums/interactionType', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/enums/interactionType', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/enums/interactionType/' + id)
  }
}
